var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.initialized
    ? _c(
        "div",
        { staticClass: "contents-list ci-content-padding-as-body-x" },
        [
          _vm.title
            ? _c("h3", {
                staticClass: "chapter mt-0",
                domProps: { textContent: _vm._s(_vm.title) },
              })
            : _vm._e(),
          _vm.hasContents
            ? [
                _c(
                  "div",
                  { staticClass: "row no-gutters-handheld with-gutter-bottom" },
                  _vm._l(_vm.contents, function (content) {
                    return _c(
                      "div",
                      {
                        key: content.slug,
                        staticClass: "col-md-6 col-lg-6 col-xl-4 d-flex",
                      },
                      [
                        _c("CiContentTile", {
                          staticClass: "w-100",
                          attrs: {
                            "tile-data": content,
                            "show-copyright": _vm.showCopyright,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-center py-3 py-md-4 news-list-load-more-container",
                  },
                  [
                    !_vm.lastPageReached
                      ? _c("CiButton", {
                          staticClass: "contents-list__load-more-button",
                          attrs: {
                            label: _vm.$t(
                              "ui.shared.global.load_more.contents"
                            ),
                            variant: "filled-primary",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.fetchContents },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : [
                _c("div", { staticClass: "p-4 text-center text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("ui.shared.global.no_data_found"))),
                ]),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }